export default __webpack_public_path__ + "static/media/checkbox.14621812.png";